import axios from 'axios'
import { endAdminSession, getAdminToken } from '../utils/functions/auth'

const urlBase = process.env.REACT_APP_URL_BACKEND_BASE

const authHeaders = () => {
  const token = getAdminToken()
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}

const handleAuthResponse = response => {
  if (response?.data?.status === 401) {
    endAdminSession()
  }
  return response
}

const buildUrl = accion => {
  let url = `${urlBase}${process.env.REACT_APP_URL_CONTENT}`
  return url.replace(':accion', accion)
}

const getBankData = async () => {
  const response = await axios.get(buildUrl('bankData'), authHeaders())
  return handleAuthResponse(response)
}

const editBankData = async bankData => {
  const response = await axios.post(buildUrl('editBankData'), bankData, authHeaders())
  return handleAuthResponse(response)
}

const getAllFaqs = async () => {
  const response = await axios.get(buildUrl('allFaqs'), authHeaders())
  return handleAuthResponse(response)
}

const addFaq = async faq => {
  const response = await axios.post(buildUrl('addFaq'), faq, authHeaders())
  return handleAuthResponse(response)
}

const editFaq = async faq => {
  const response = await axios.post(buildUrl('editFaq'), faq, authHeaders())
  return handleAuthResponse(response)
}

const deleteFaq = async id => {
  const response = await axios.post(buildUrl('deleteFaq'), { id }, authHeaders())
  return handleAuthResponse(response)
}

const getAllSocials = async () => {
  const response = await axios.get(buildUrl('allSocials'), authHeaders())
  return handleAuthResponse(response)
}

const addSocial = async social => {
  const response = await axios.post(buildUrl('addSocial'), social, authHeaders())
  return handleAuthResponse(response)
}

const editSocial = async social => {
  const response = await axios.post(buildUrl('editSocial'), social, authHeaders())
  return handleAuthResponse(response)
}

const deleteSocial = async id => {
  const response = await axios.post(buildUrl('deleteSocial'), { id }, authHeaders())
  return handleAuthResponse(response)
}

// Dispara un envío de prueba con los templates reales, sin pasar por una compra.
const sendTestEmail = async ({ email, tipo }) => {
  const response = await axios.post(
    `${urlBase}${process.env.REACT_APP_URL_TEST_EMAIL}`,
    { email, tipo },
    authHeaders()
  )
  return handleAuthResponse(response)
}

export const contentService = {
  getBankData,
  editBankData,
  getAllFaqs,
  addFaq,
  editFaq,
  deleteFaq,
  getAllSocials,
  addSocial,
  editSocial,
  deleteSocial,
  sendTestEmail
}
